export function getSplitId(id: string) {
    if (!id) return
    return id.split(':')
}
